import { normalizeFilename } from "./normalizeFilename"
import React, { useRef, Fragment } from "react"
import { checkFileValidations } from "./checkFileValidations"
import { FileBox, UPLOADER_TYPE } from "../fileBox/FileBox"
import { UploaderContent } from "../fileBox/UploaderContent"

const PropTypes = require("prop-types")


export const DragNDropUpload = ({
    idName,
    validTypes,
    onChange,
}) => {
    const uploadFileRef = useRef(null)

    const processFile = (fileToHandle) => new Promise((resolve) => {
        const newFilename = normalizeFilename(fileToHandle.name)
        const file = new File([fileToHandle], newFilename, { type: fileToHandle.type })
        const reader = new FileReader()

        reader.readAsDataURL(file)

        reader.onloadend = (evt) => {
            const validationError = checkFileValidations(file)

            const newFile = {
                id: new Date().valueOf() + Math.random(),
                file,
                base64: evt.target.result,
                validationError,
            }

            resolve(newFile)
        }
    })

    const handleUploadPicture = (evt) => {
        evt.preventDefault()
        uploadFileRef.current.click()
    }

    const handleDragOver = (evt) => {
        evt.stopPropagation()
        evt.preventDefault()
    }

    const handleDragEnter = (evt) => {
        evt.stopPropagation()
        evt.preventDefault()
    }

    const handleDragLeave = (evt) => {
        evt.stopPropagation()
        evt.preventDefault()
    }

    const handleDropImage = (evt) => {
        let files

        evt.preventDefault()

        if (evt.dataTransfer) {
            files = evt.dataTransfer.files
        } else if (evt.target) {
            files = evt.target.files
        }

        if (!files) {
            return
        }

        const processAllFilesPromises = Array.from(files).map(file => {
            return processFile(file)
        })

        Promise.all(processAllFilesPromises).then((allFiles) => {
            onChange([...allFiles])
            uploadFileRef.current.value = ""
        })
    }

    return (
        <Fragment>
            <FileBox
                onDragOver={handleDragOver}
                onDragEnter={handleDragEnter}
                onDragLeave={handleDragLeave}
                onDrop={handleDropImage}
                type={UPLOADER_TYPE}
            >
                <UploaderContent onClick={handleUploadPicture} />
            </FileBox>
            <input
                style={{ display: "none" }}
                type="file"
                multiple={true}
                ref={uploadFileRef}
                onChange={handleDropImage}
                name={idName}
                accept={validTypes.join(", ")}
            />
        </Fragment>
    )
}

DragNDropUpload.propTypes = {
    validTypes: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    idName: PropTypes.string.isRequired,
}
